define( [ 'jquery', 'utility' ], function( $, util ) {
	'use strict';

	var faqlist = {
		init : function( el ) {
			this.create( $( el ) );
		},

		create : function( element ) {
			if ( !element.hasClass( 'js-a-list-faq' ) ) {
				var self = this;

				element.addClass( 'js-a-list-faq' );

				element.find( 'dt' ).each( function() {
					var $this = $( this ),
						faqID = $this.attr( 'id' );

					// Create a unique id for the faq answer
					if ( faqID ) {
						faqID = 'a-list-faq__answer__' + faqID;
					} else {
						faqID = util.makeId( 'a-list-faq__answer__' );
					}

					$this.next().attr({
						'id' : faqID,
						'aria-hidden' : 'true'
					});

					$this.wrapInner( '<a class="a-list-faq__control" href="#' + faqID + '" aria-controls="' + faqID + '" aria-expanded="false"></a>' );
				});

				// Add a click event to the control to open the associated element
				element.on( 'click', '.a-list-faq__control', function( e ) {
					e.preventDefault();

					self.open( $( this ) );
				});

				element.prev( '.a-list-faq-back-link' ).on( 'click', function( e ) {
					e.preventDefault();

					self.close( $( this ) );
				});
			}
		},

		open : function( element ) {
			var $this = element,
				$thisparent = $this.parent();

			$this.attr({
				'aria-expanded' : 'true',
				'tabindex' : -1
			});

			$thisparent.addClass( 'is-visible' ).attr( 'aria-hidden', 'false' );
			$thisparent.next()
				.show( 400 )
				.attr( 'aria-hidden', 'false' );
			$thisparent.siblings( '.a-list-faq__question' )
				.attr( 'aria-hidden', 'true' )
				.hide( 350 );
			$thisparent.parents( '.a-list-faq' )
				.siblings( '.a-list-faq-back-link' )
				.attr( 'aria-hidden', 'false' )
				.show( 350 )
				.children( 'a' )
				.focus();
		},

		close : function( element ) {
			element.hide( 350 );

			var $thisFaqList = element.next( '.a-list-faq' );

			$thisFaqList.find( '.a-list-faq__control[tabindex="-1"]' )
				.removeAttr( 'tabindex' )
				.focus();
			$thisFaqList.find( '.a-list-faq__control' ).attr( 'aria-expanded', 'false' );
			$thisFaqList.children( '.a-list-faq__question' )
				.removeClass( 'is-visible' )
				.attr( 'aria-hidden', 'false' )
				.show( 350 );
			$thisFaqList.children( '.a-list-faq__answer' )
				.attr( 'aria-hidden', 'true' )
				.hide( 350 );
		}
	};

	return {
		initInstance : function( el ) {
			faqlist.init( el );
		}
	};
});
